import React from 'react';
import { default as NextLink } from 'next/link';
import { convertAbsoluteLinkToRelative } from '@/utils';
import { Box } from '@/components';
import { AnimationProps } from '../animation/Box';
import { ApiLinkModel } from '@/client';

interface ILinkProps extends AnimationProps {
  link: ApiLinkModel;
  children?: React.ReactNode;
  ariaLabel?: string;
  className?: string;
}

const Link = ({ animate = false, animation, link, children, ariaLabel, ...props }: ILinkProps) => {
  if (!link) return;

  const fixedLink = convertAbsoluteLinkToRelative(link);

  const linkObj = (
    <NextLink
      href={fixedLink?.url || fixedLink.route?.path || ''}
      target={fixedLink?.target || undefined}
      aria-label={fixedLink?.target === '_blank' ? ariaLabel || link?.title || undefined : undefined}
      {...props}
    >
      {children || link?.title}
    </NextLink>
  );

  return !animate && !animation ? linkObj : <Box animation={animation}>{linkObj}</Box>;
};

Link.displayName = 'Link';

export default Link;
